/**
 * @generated SignedSource<<c35d185f406023df9be185b81fa7cc8a>>
 * @relayHash f4e1536d60cedcc8ed6f06ed1e244a8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 616d022cc828b9f648fdd7ed6490f84a420e7887c039bd0610fa0413fa5b1cec

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type createVirtualAgentConfirmationModalMutation$variables = {
  defaultRequestTypeId?: string | null | undefined;
  jiraProjectId: string;
};
export type createVirtualAgentConfirmationModalMutation$data = {
  readonly virtualAgent: {
    readonly createVirtualAgentConfiguration: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
      readonly virtualAgentConfiguration: {
        readonly __id: string;
        readonly defaultJiraRequestTypeId: string | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type createVirtualAgentConfirmationModalMutation = {
  response: createVirtualAgentConfirmationModalMutation$data;
  variables: createVirtualAgentConfirmationModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "defaultRequestTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraProjectId"
},
v2 = [
  {
    "concreteType": "VirtualAgentMutationApi",
    "kind": "LinkedField",
    "name": "virtualAgent",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "defaultJiraRequestTypeId",
                "variableName": "defaultRequestTypeId"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          },
          {
            "kind": "Variable",
            "name": "jiraProjectId",
            "variableName": "jiraProjectId"
          }
        ],
        "concreteType": "VirtualAgentCreateConfigurationPayload",
        "kind": "LinkedField",
        "name": "createVirtualAgentConfiguration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "VirtualAgentConfiguration",
            "kind": "LinkedField",
            "name": "virtualAgentConfiguration",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "defaultJiraRequestTypeId"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "createVirtualAgentConfirmationModalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "createVirtualAgentConfirmationModalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "616d022cc828b9f648fdd7ed6490f84a420e7887c039bd0610fa0413fa5b1cec",
    "metadata": {},
    "name": "createVirtualAgentConfirmationModalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e0f3e6f48120f197fccf278e6ba75ea9";

export default node;
